import {ApprovalStage, NoActionStage, Stage} from "../../../api/application/getApplicationDetails";

const relativeTimeFormat = new Intl.RelativeTimeFormat('en', { style: 'long' });

export const getIsCompleted = (stage: Stage) => {
    return stage.stageStatus === 'APPROVED' || stage.stageStatus === 'REJECTED'
}

export const getSubtitle = (stage: NoActionStage | ApprovalStage): string => {
    const now = new Date()
    const date = new Date(new Date(stage.updatedAt).getTime() + (stage.waitTime * 60000))

    const isCompleted = getIsCompleted(stage)

    const diffTime = date.getTime() - now.getTime()
    const diffDays = diffTime / (1000 * 60 * 60 * 24)
    const diffHours = diffTime / (1000 * 60 * 60)

    const diff =  diffDays > 1
        ? relativeTimeFormat.format(Math.round(diffDays), 'day')
        : relativeTimeFormat.format(Math.round(diffHours), 'hour')

    return isCompleted
        ? `${stage.stageStatus === 'REJECTED' ? 'Rejected' : 'Completed'} on ${new Date(stage.updatedAt).toDateString()}`
        : date < now
            ? 'Sorry, It takes more than it should.'
            : `Estimated Waiting: ${diff}`
}
